import { useState, useEffect } from "react";

export interface ContentAreaRect {
  centerX: number;
  top: number;
  left: number;
  width: number;
  height: number;
}

export const useContentAreaRect = (): ContentAreaRect | null => {
  const [rect, setRect] = useState<ContentAreaRect | null>(null);

  useEffect(() => {
    const el = document.querySelector('[data-slot="sidebar-inset"]');
    if (!el) {
      return;
    }

    const update = () => {
      const { top, left, width, height } = el.getBoundingClientRect();
      setRect({ centerX: left + width / 2, top, left, width, height });
    };

    const observer = new ResizeObserver(update);
    observer.observe(el);
    update();

    return () => observer.disconnect();
  }, []);

  return rect;
};
